import React from 'react';
import { HiBadgeCheck } from 'react-icons/hi';
import './experience.css';
const Experience = () => {
  return (
    <section id="experience">
      <h5>The Skills I Have</h5>
      <h2>Skills</h2>
      <div className="skills">
        <div className="container">
          <h3>Front-End</h3>
          <div className="experience-container">
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>HTML/CSS</h4>
            </article>
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>JavaScript</h4>
            </article>
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>React</h4>
            </article>
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>GitHub</h4>
            </article>
          </div>
        </div>

        <div className="container">
          <h3>Back-End</h3>
          <div className="experience-container">
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>Python(Django)</h4>
            </article>
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>C#(.NET WPF)</h4>
            </article> 
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>SQL and NoSQL</h4>
            </article>
            <article className="experience-details">
              <HiBadgeCheck className="experience-icons" />
              <h4>Docker</h4>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
